import { gql } from 'src/__generated__';

export const PROCESS_UPLOADED_ATTACHMENT = gql(`
  mutation ApplyProcessUploadedAttachment(
    $input: ProcessUploadedAttachmentInput!
  ) {
    processUploadedAttachment(input: $input) {
      uri
    }
  }
`);
